<template>
  <div id="app">
    <div class="nav-center t2">
      <Header id="header" />

      <div class="nav-bar"></div>

      <div id="nav">
        <van-row type="">
          <van-col span="22">
            <!-- 导航栏 -->
            <van-tabs
              id="tabs"
              class="nav-ul"
              v-model="active"
              color="red"
              swipeable
              animated
              title-active-color="red"
              title-inactive-color="#121111"
              @click="selCategory"
              ref="tabs"
            >
              <van-tab
                class="navLi"
                v-for="list in headerList"
                :name="list.categoryId"
                :key="list.categoryId"
                :title="list.categoryName"
              >
              </van-tab>
            </van-tabs>
          </van-col>

          <van-col span="2" class="nav-show-all" @click="navShowAll">
            <img class="" alt="" src="../../assets/img/icon_list.png" />
          </van-col>
        </van-row>
      </div>

      <div id="content">
        <iframe
          v-if="thirdUrl"
          id="listIframe"
          class="list-iframe"
          :src="listUrl"
          :title="iframe"
          frameborder="”no”"
          border="”0″"
          scrolling="auto"
        >
        </iframe>

        <van-pull-refresh
          v-if="!thirdUrl"
          v-model="isLoading"
          success-text="刷新成功"
          @refresh="onRefresh"
          id="pullList"
        >
          <!-- 通知栏 -->
          <!-- <van-notice-bar class="notice-bar" left-icon="volume-o" color="#fff" 
								delay="3" :text="nowNewsText" /> -->

          <div id="" class="swipe-first" v-if="showSwiper">
            <!-- 轮播图片 -->
            <van-swipe :autoplay="5000" :duration="1000" class="first-news">
              <van-swipe-item v-for="(list, index) in firstImage" :key="index">
                <div class="card">
                  <div @click="goNewsInfo(list.newsUrl)">
                    <!-- <van-image width="100%" fit="cover" :src="list.imgUrl + ' '" /> -->
                    <div class="zooImage_con">
                      <div
                        class="zoomImage"
                        :style="'background-image: url(' + list.imgUrl + ')'"
                      ></div>
                      <div class="cardName">{{ list.title }}</div>
                    </div>
                  </div>
                  <!-- <div class="cardName2">{{getNavNameStr( list.categoryId )}} {{timeStr( list.publishTime )}} -->
                  <!-- <div class="cardshare" @click="goShare">
											<img class="" alt="分享" src="../../assets/img/icon_id.png">
										</div> -->
                  <!-- </div> -->
                </div>
              </van-swipe-item>
            </van-swipe>
          </div>
          <div v-if="!showSwiper">
            <div class="card2" v-for="(list, index) in firstNews" :key="index">
              <div @click="goNewsInfo(list.newsUrl)" class="noPicNews">
                {{ list.title }}
              </div>
              <div class="cardName2">
                {{ getNavNameStr(list.categoryId) }}
                {{ timeStr(list.publishTime) }}
              </div>
            </div>
          </div>

          <!-- 新闻 -->
          <ul id="order-list" class="newList">
            <li v-for="(list, index) in newsList" :key="genRandomKey(list.id)">
              <!-- 如果不是广告 -->
              <div v-if="list.isAd != 'isAd'">
                <!-- 如果点击更多(不是第一页) && 是广告位的上一个 和 下一个(根据翻页的广告位置变化) 就强制显示小图 -->
                <div
                  v-if="
                    isMoreFlag &&
                      (index ==
                        newsList.length - bwt_adv_position2_offset - 2 ||
                        index == newsList.length - bwt_adv_position2_offset)
                  "
                >
                  <!-- 小图 -->
                  <div
                    class="card2"
                    v-if="
                      list.newsFlag != 1000 &&
                        !list.isAd &&
                        list.imgUrl &&
                        list.imgUrl.length > 0 &&
                        list.categoryId != 100
                    "
                  >
                    <div @click="goNewsInfo(list.newsUrl)" class="img-div">
                      <div class="zooImage_con">
                        <div
                          class="zoomImage"
                          :style="'background-image: url(' + list.imgUrl + ')'"
                        ></div>
                      </div>

                      <div class="cardName">{{ list.title }}</div>
                    </div>
                    <div class="cardName2">
                      {{ getNavNameStr(list.categoryId) }}
                      {{ timeStr(list.publishTime) }}
                    </div>
                  </div>
                </div>

                <!-- 如果没有点击更多(是第一页) 正常判断大小图 -->

                <div v-else>
                  <!-- 大图 -->
                  <div
                    class="card"
                    v-if="
                      ((list.newsType == 5 || list.newsType == 4) &&
                        index != 0 &&
                        index != 1 &&
                        list.newsFlag != 1000) ||
                        list.categoryId == 100
                    "
                  >
                    <div @click="goNewsInfo(list.newsUrl)">
                      <div class="cardName cardNameTop">{{ list.title }}</div>
                      <!-- <van-image width="100%" fit="contain" :src="list.imgUrl + ' '" /> -->
                      <div class="zooImage_con">
                        <div
                          class="zoomImage"
                          :style="'background-image: url(' + list.imgUrl + ')'"
                        ></div>
                      </div>
                    </div>
                    <div class="cardName2">
                      {{ getNavNameStr(list.categoryId) }}
                      {{ timeStr(list.publishTime) }}
                    </div>
                  </div>

                  <!-- 小图 -->
                  <div
                    class="card2"
                    v-if="
                      ((list.newsType != 5 &&
                        list.newsType != 4 &&
                        list.newsType != 1) ||
                        (index == 0 && list.newsType != 1) ||
                        (index == 1 &&
                          list.newsType != 1 &&
                          list.newsFlag != 1000)) &&
                        list.categoryId != 100
                    "
                  >
                    <div @click="goNewsInfo(list.newsUrl)" class="img-div">
                      <!-- <van-image fit="cover" :src="list.imgUrl + ' '" /> -->
                      <div class="zooImage_con">
                        <div
                          class="zoomImage"
                          :style="'background-image: url(' + list.imgUrl + ')'"
                        ></div>
                      </div>

                      <div class="cardName">{{ list.title }}</div>
                    </div>
                    <div class="cardName2">
                      {{ getNavNameStr(list.categoryId) }}
                      {{ timeStr(list.publishTime) }}
                    </div>
                  </div>
                </div>

                <!-- 专题 -->
                <div
                  class="card"
                  v-if="
                    (list.newsType == 5 || list.newsType == 4) &&
                      index != 0 &&
                      index != 1 &&
                      list.newsFlag == 1000 &&
                      list.isAd != 'isAd'
                  "
                >
                  <div @click="goNewsInfo(list.newsUrl)">
                    <div class="zooImage_con">
                      <div
                        class="zoomImage topic"
                        :style="'background-image: url(' + list.imgUrl + ')'"
                      ></div>
                    </div>
                  </div>
                </div>

                <!-- 无图 -->
                <div
                  class="card2"
                  v-if="
                    list.newsType == 1 ||
                      (list.categoryId == 99 && list.isAd != 'isAd')
                  "
                >
                  <div @click="goNewsInfo(list.newsUrl)" class="noPicNews">
                    {{ list.title }}
                  </div>
                  <div class="cardName2">
                    {{ getNavNameStr(list.categoryId) }}
                    {{ timeStr(list.publishTime) }}
                  </div>
                </div>
              </div>

              <!-- 广告 -->
              <div
                class="ad_con"
                v-if="
                  index == bwt_adv_position - 2 && !isLocalChannel(curCatId)
                "
              >
                <iframe
                  id="ad_iframe"
                  ref="ad_con"
                  frameborder="0"
                  scrolling="no"
                  :src="siteChannelId(1, curCatId)"
                ></iframe>
              </div>

              <!-- 財經熱點 -->
              <div class="hotSpot" v-if="index == 3 && curCatId == 1">
                <div class="itemTitle" @click="goItem('104')">財經熱點</div>
                <swiper class="swiper" :options="swiperOption">
                  <swiper-slide v-for="list in hotSpot" :key="list.id">
                    <div class="card hot">
                      <div @click="goNewsInfo(list.newsUrl)">
                        <van-image fit="cover" :src="list.imgUrl + ' '">
                          <template v-slot:loading>
                            <van-loading type="spinner" size="0" />
                          </template>
                        </van-image>
                        <div class="cardName">{{ list.title }}</div>
                      </div>
                      <div class="cardName2">
                        {{ getNavNameStr(list.categoryId) }}
                        {{ timeStr(list.publishTime) }}
                      </div>
                    </div>
                  </swiper-slide>
                </swiper>
              </div>

              <!-- 广告2 -->
              <!-- <div class="ad_con" v-if="index==bwt_adv_position-1 && curCatId==1">
								<iframe id="ad_iframe" ref="ad_con" frameborder="0" scrolling="no" :src="siteChannelId(2,curCatId)"></iframe>
							</div> -->

              <!-- 每日精選 -->
              <div class="choiceNews" v-if="index == 5 && curCatId == 1">
                <div class="itemTitle" @click="goItem('105')">每日精選</div>
                <swiper class="swiper" :options="swiperOption">
                  <swiper-slide v-for="list in choiceNews" :key="list.id">
                    <div class="card choice">
                      <div @click="goNewsInfo(list.newsUrl)">
                        <van-image
                          width="100%"
                          fit="cover"
                          :src="list.imgUrl + ' '"
                        >
                          <template v-slot:loading>
                            <van-loading type="spinner" size="0" />
                          </template>
                        </van-image>
                        <div class="cardName">{{ list.title }}</div>
                      </div>
                      <div class="cardName2">
                        {{ getNavNameStr(list.categoryId) }}
                        {{ timeStr(list.publishTime) }}
                      </div>
                    </div>
                  </swiper-slide>
                </swiper>
              </div>

              <!-- 广告 加载更多 中 -->
              <div v-if="isMoreFlag">
                <!-- 如果 文章的总数-10新增的数据 + 广告位值-1 && 首页 && 加载更多了一次 -->
                <!-- <div class="ad_con" v-if="index==(newsList.length-10) + (bwt_adv_position2-2) && curCatId==1 && !homeMoreIsAddedAd">
									<iframe id="ad_iframe" ref="ad_con" frameborder="0" scrolling="no" src="//ads.adserver.newsochub.com/show/std?scid=591&f=iframe"></iframe>
								</div> -->

                <!-- 如果 文章的总数-bwt_adv_position2_offset新增的数据 -->
                <div
                  class="ad_con"
                  v-if="list.isAd == 'isAd' && !isLocalChannel(curCatId)"
                >
                  <iframe
                    id="ad_iframe"
                    ref="ad_con"
                    frameborder="0"
                    scrolling="no"
                    :src="siteChannelId(1, curCatId)"
                  ></iframe>
                </div>
              </div>
            </li>
          </ul>
        </van-pull-refresh>
      </div>

      <div class="more-news-btn" v-if="!thirdUrl">
        <van-button
          plain
          hairline
          type="primary"
          color="#1A1E28"
          @click="moreNewsBtn"
        >
          <div>
            查看更多
            <img
              class=""
              alt="查看更多"
              src="../../assets/img/nav_list_more.png"
            />
          </div>
        </van-button>
      </div>

      <div>
        <!-- 导航菜单弹出层 -->
        <van-popup
          v-model="navsShow"
          closeable
          :overlay-style="{ backgroundColor: 'transparent' }"
          position="bottom"
          :style="{ height: '91%' }"
          @close="navPopClose"
        >
          <div class="nav-popup">
            <!--使用draggable组件-->
            <div class="drag_nav row1">
              <span class="d_title">我的頻道</span>
              <van-tabs
                class="nav_Tabs"
                type="card"
                title-inactive-color="#000"
                title-active-color="#000"
                color="#fff"
                animated
                swipeable
                :ellipsis="false"
                @click="switchNavTabs"
              >
                <van-tab name="1" title="自定義"></van-tab>
                <van-tab name="0" title="默認"></van-tab>
              </van-tabs>
              <div class="btn_div">
                <div class="btn_edit_nav" @click="returnOriginal">還原</div>
                <div class="btn_edit_nav text_edit" @click="editNav">編輯</div>
                <div class="btnNavTemp" v-for="i in 2" :key="i"></div>
              </div>
            </div>

            <div v-show="navCostomShow">
              <draggable
                class="drag moveDrag1"
                v-model="headerList"
                chosenClass="chosen"
                forceFallback="true"
                handle=".mov"
                group="nav"
                animation="500"
                :disabled="disableDragable"
                @end="onEnd"
                :move="onMove"
                :delay="100"
                :start="onStart"
              >
                <div
                  :class="e.categoryId == 1 ? 'item' : 'item mov moveDrag1'"
                  v-for="(e, index) in headerList"
                  :key="e.categoryId"
                  @click="catClickEnable && goNav(e.categoryId)"
                >
                  <span
                    :class="
                      e.categoryId != 1 &&
                      e.categoryId != 98 &&
                      e.categoryId != 99 &&
                      e.categoryId != 999
                        ? 'del'
                        : 'delNone'
                    "
                    v-show="isDel"
                    @click="catDelEnable && delNav(index, e.categoryType)"
                    >x</span
                  >{{ e.categoryName }}
                </div>
                <div
                  class="itemTemp moveDrag1"
                  v-for="i in 5"
                  :key="'itemTemp' + i"
                ></div>
              </draggable>

              <div class="drag_nav">
                <span class="d_title">全部頻道 </span
                ><span class="d_desc">點擊添加頻道</span>
              </div>
              <draggable
                class="drag moveDrag2"
                v-model="headerList2"
                chosenClass="chosen"
                forceFallback="true"
                group="nav"
                animation="500"
                :disabled="disableDragable"
                @end="onEnd"
                :move="onMove"
                :delay="100"
              >
                <div
                  class="item item2 mov moveDrag2"
                  v-for="(e, index) in headerList2"
                  :key="e.categoryId"
                  @click="addNav(index)"
                >
                  +{{ e.categoryName }}
                </div>
                <div
                  class="itemTemp2 moveDrag2"
                  v-for="i in 5"
                  :key="'itemTemp2' + i"
                ></div>
              </draggable>

              <div class="drag_nav">
                <span class="d_title">地方頻道 </span
                ><span class="d_desc">點擊添加頻道</span>
              </div>
              <draggable
                class="drag moveDrag3"
                v-model="headerList3"
                chosenClass="chosen"
                forceFallback="true"
                group="nav"
                animation="500"
                :disabled="disableDragable"
                @end="onEnd"
                :move="onMove"
                :delay="100"
              >
                <div
                  class="item item2 mov moveDrag3"
                  v-for="(e, index) in headerList3"
                  :key="e.categoryId"
                  @click="addNavLocal(index)"
                >
                  +{{ e.categoryName }}
                </div>
                <div
                  class="itemTemp2 moveDrag3"
                  v-for="i in 5"
                  :key="'itemTemp3' + i"
                ></div>
              </draggable>
            </div>

            <div v-show="navDefaultShow">
              <div class="drag">
                <div
                  v-for="e in originalHeaderList"
                  :key="e.categoryId"
                  :class="e.categoryType != 1 ? 'item' : 'item hide'"
                >
                  <div @click="goNav(e.categoryId)">{{ e.categoryName }}</div>
                </div>
                <div
                  class="itemTemp"
                  v-for="i in 6"
                  :key="'defaultItemTemp' + i"
                ></div>
              </div>
              <!-- <ul>
								<li fon v-for="(list) in originalHeaderList"
										:name="list.categoryId" :key="list.categoryId" :title="list.categoryName"
										@click="goNav(list.categoryId)">{{list.categoryName}}</li>
							</ul> -->
              <div class="drag_nav">
                <span class="d_title">地方頻道 </span
                ><span class="d_desc">點擊添加頻道</span>
              </div>
              <div class="drag">
                <div
                  v-for="e in originalHeaderList"
                  :key="e.categoryId"
                  :class="e.categoryType == 1 ? 'item' : 'item hide'"
                >
                  <div @click="goNav(e.categoryId)">{{ e.categoryName }}</div>
                </div>
                <div
                  class="itemTemp2"
                  v-for="i in 6"
                  :key="'defaultItemTemp2' + i"
                ></div>
              </div>
            </div>
          </div>
        </van-popup>
      </div>
    </div>

    <Footer id="footer" />
  </div>
</template>

<script>
import $ from 'Jquery'
import Header from '@/components/header/header.vue'
import Footer from '@/components/footer/footer.vue'
import { getNav, getNewsList, tongjiPhp, getAdChannelId } from '@/js/api.js'
import {
  redirect,
  publishedTime,
  getNavName,
  getUrlParam,
  tongji,
} from '@/js/util.js'

import './index.js'

import Vue from 'vue'
import {
  Image as VanImage,
  Tab,
  Tabs,
  PullRefresh,
  Button,
  Col,
  Row,
  Popup,
  Swipe,
  SwipeItem,
  NoticeBar,
  Loading,
} from 'vant'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'

import 'vant/lib/tab/style'
import 'vant/lib/tabs/style'
import 'vant/lib/pull-refresh/style'
import 'vant/lib/button/style'
import 'vant/lib/col/style'
import 'vant/lib/row/style'
import 'vant/lib/popup/style'
import 'vant/lib/swipe/style'
import 'vant/lib/swipe-item/style'
import 'vant/lib/notice-bar/style'
import 'vant/lib/loading/style'
import 'swiper/css/swiper.css'
import draggable from 'vuedraggable'

Vue.use(VanImage)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(PullRefresh)
Vue.use(Button)
Vue.use(Col)
Vue.use(Row)
Vue.use(Popup)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(NoticeBar)
Vue.use(Loading)

export default {
  name: 'app',
  data() {
    return {
      active: 0, //导航栏默认选择
      activeBeforeHomeDel: 1, //导航栏 Home被删除之前
      isLoading: false,
      navsShow: false,
      headerList: [], //导航我的频道list
      // nowNewsList: [],	//即时新闻 滚动通知
      // nowNewsText: '',
      firstImage: [],
      newsList: [],
      hotSpot: [], //財經熱點
      choiceNews: [], //每日精選
      curCatId: 1, //当前类别id
      curPage: 1, //当前第几页
      swiperOption: {
        loop: true,
        slidesPerView: 2,
        spaceBetween: 10,
        freeMode: true,
        centeredSlides: true,
        initialSlide: 1,
      },
      showSwiper: true,
      firstNews: [],
      headerList3: [], //导航地方频道list
      originalHeaderList: [], //原始導航數據
      originalLocalHeaderList: [], //原始導航數據 地方频道(山东 江苏)
      drag: false,
      disableDragable: true, //是否不可拖动
      isDel: false, //是否可刪除
      headerList2: [], //导航全部频道list
      navChecked: false,
      isNavDefaultRefreshed: false, //导航点击默认的时候请求一次数据 获取数据后改为true 页面刷新前不用在请求

      navDefaultShow: false, //默认导航 隐藏
      navCostomShow: true, //自定义导航显示
      catClickEnable: true, //弹窗中的我的频道是否可以点击
      catDelEnable: true, //弹窗中的我的频道是否可以删除 小于等于5个不能删除

      listUrl: 'http://www.hkcd.com.hk/hkcdweb/topic.list.m.html', //专题跳转url
      thirdUrl: false,
      twoMeetingsUrl: '', //两会跳转url
      xiamenUrl: '', //厦门跳转url

      isMoreFlag: false, //是否点击加载按钮 加载更多时

      bwt_adv_position: 4, //广告位置
      bwt_adv_position2: 5, //广告位置2
      bwt_adv_position2_offset: 6, //广告位置2偏移

      homeMoreAddTimes: 0, //首页显示更多次数
      homeMoreIsAddedAd: false, //首页显示更多时只显示多一次广告 是否已经显示了一次

      adChannelIdArr: [], //每个频道的广告channelId

      placeId: [107, 108, 114, 115, 116, 117, 202, 118, 119, 313, 314],
    }
  },
  components: {
    Header,
    Footer,
    Swiper,
    SwiperSlide,
    draggable,
  },
  created() {
    this.getAdChannelId()
  },
  computed: {
    timeStr() {
      return function(str) {
        return publishedTime(str)
      }
    },
    getNavNameStr() {
      return function(categoryId) {
        let nl = this.headerList
        return getNavName(nl, categoryId)
      }
    },
  },
  methods: {
    onRefresh() {
      //下拉刷新
      setTimeout(() => {
        this.isLoading = false
        this.curPage = 1
        this.getNews()
      }, 1000)
    },
    selCategory(id, title) {
      //选择类别 vant tab事件
      console.log('选择导航id：' + id)
      console.log('标题：' + title)

      this.curCatId = id //设置当前类别
      this.curPage = 1 //设置回第一页

      this.getNews(id)

      this.isMoreFlag = false

      this.homeMoreAddTimes = 0
      this.homeMoreIsAddedAd = false

      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0

      this.tongjiPhp()
    },
    getNews(id) {
      //获取新闻页面
      if (id == 201 || id == 98 || id == 999 || id == 203 || id == 202) {
        if (id == 201) {
          this.listUrl = 'https://www.hkcd.com.hk/hkcdweb/topic.list.m.html'
        } else if (id == 98) {
          window.location.href = 'http://ebook.hkcd.com.hk/PC/layout/'
          // this.listUrl = "http://ebook.hkcd.com/PC/layout/";
        } else if (id == 999) {
          window.location.href = 'http://hk.hkcd.com.hk/pdf/index.htm'
          // this.listUrl = "http://hk.hkcd.com.hk/pdf/index.htm";
        } else if (id == 203) {
          console.log('this.twoMeetingsUrl', this.twoMeetingsUrl)
          this.listUrl = this.twoMeetingsUrl
        } else if (id == 202) {
          this.listUrl = this.xiamenUrl
        }
        this.thirdUrl = true
        this.$nextTick(function() {
          /**
           * iframe-宽高自适应显示
           */
          const oIframe = document.getElementById('listIframe')
          // const deviceWidth = document.documentElement.clientWidth
          const deviceHeight = document.documentElement.clientHeight
          // // oIframe.style.width = (Number(deviceWidth)-0) + 'px'; //数字是页面布局宽度差值
          oIframe.style.height = Number(deviceHeight) + 0 + 'px' //数字是页面布局高度差
          // $(".topic-list a").each(function(){$(this).attr("target","_self")});
          const iframe = document.querySelector('#listIframe')
          if (iframe.attachEvent) {
            iframe.attachEvent('onload', function() {
              const iframeNode =
                window.frames['listIframe'].contentWindow.document
              console.log(iframeNode)
              var ifdoc = $(
                '.topic-list',
                $('#listIframe').contentWindow.document
              )
              for (var i = 0; i < ifdoc.childNodes.length; i++) {
                ifdoc.childNodes[i].target = '_self'
              }
            })
          } else {
            iframe.onload = function() {
              const iframeNode =
                window.frames['listIframe'].contentWindow.document
              var oMeta = document.createElement('meta')
              oMeta.content =
                'width=device-width, initial-scale=1.0, maximum-scale=1.0,minimum-scale=1.0, user-scalable=0'
              oMeta.name = 'viewport'
              iframeNode.getElementsByTagName('head')[0].appendChild(oMeta)
              var ifdoc = window.frames[
                'listIframe'
              ].contentWindow.document.getElementsByClassName('topic-list')[0]
              // var ifdoc = $(".topic-list",$("#listIframe").contentWindow.document);
              console.log(ifdoc)
              for (var i = 0; i < ifdoc.childNodes.length; i++) {
                ifdoc.childNodes[i].target = '_self'
              }
            }
          }
        })
        return
      }

      this.thirdUrl = false
      getNewsList([this.curCatId, this.curPage])
        .then((response) => {
          this.newsList = []
          this.newsList = response.data.data.arr

          this.bwt_adv_position = response.data.data.ext.bwt_adv_position

          this.firstNews = []
          if (response.data.data.first.length == 0) {
            this.showSwiper = false
            this.firstNews = response.data.data.first
          } else {
            //获取首页轮播图
            this.showSwiper = true
            this.firstImage = response.data.data.first
          }

          //財經熱點
          this.hotSpot = []
          if (response.data.data.hotSpot) {
            this.hotSpot = response.data.data.hotSpot.item
          }
          //每日精選
          this.choiceNews = []
          if (response.data.data.choiceNews) {
            this.choiceNews = response.data.data.choiceNews.item
          }

          this.$nextTick(function() {
            console.log(this.$refs['ad_con'])
            console.log(document.getElementById('ad_iframe'))

            var i = document.getElementById('ad_iframe')
            // console.log("原iframe:"+i.innerHTML+"<br>");
            // i.innerHTML="Hello world!";
            // console.log("new iframe:"+i.innerHTML+"<br>");

            // const iframe = window.frames['ad_iframe']
            // const handleLoad = () => {
            // 	setTimeout(() => {
            // 		const Do = (iframe.contentWindow || iframe.contentDocument)
            // 		Do.document.getElementById('banner').style.width = '100%'
            // 	}, 500)
            // 	}
            // 	iframe.addEventListener('load', handleLoad, true)
          })
        })
        .catch(function(error) {
          console.log(error)
        })
    },
    moreNewsBtn() {
      //加载更多
      this.homeMoreAddTimes++
      if (this.homeMoreAddTimes >= 2) {
        this.homeMoreIsAddedAd = true //首页已经点击了一次加载更多并且显示了多一次广告
      }

      getNewsList([this.curCatId, this.curPage + 1])
        .then((response) => {
          let moreArrTemp = response.data.data.arr
          let moreArr = []

          //遍历时增加广告占位
          let setPos = moreArrTemp.length - this.bwt_adv_position2_offset //要放的位置
          let adObj = {
            isAd: 'isAd',
            setPos: setPos,
          }
          for (let i = 0; i < moreArrTemp.length; i++) {
            if (i == setPos) {
              moreArr.push(adObj)
            }
            moreArr.push(moreArrTemp[i])
          }

          this.bwt_adv_position2 = response.data.data.ext.bwt_adv_position

          // 加载更多时
          this.isMoreFlag = true

          this.newsList = this.newsList.concat(moreArr)
          this.curPage = this.curPage + 1
        })
        .catch(function(error) {
          console.log(error)
        })
    },
    navShowAll() {
      //弹出导航菜单
      this.navsShow = true
    },
    goNav(id) {
      //弹出的导航菜单中选择了一个类别
      this.curCatId = id //设置当前类别
      this.curPage = 1 //设置回第一页

      this.getNews(id)

      this.navsShow = false //关闭导航菜单弹出窗口
      this.isMoreFlag = false

      this.homeMoreAddTimes = 0
      this.homeMoreIsAddedAd = false

      this.active = id //设置当前导航位置
      this.activeBeforeHomeDel = this.active

      this.tongjiPhp()
    },
    goNewsInfo(newsUrl) {
      redirect('/news-info.html?newsUrl=' + newsUrl)
    },
    goShare() {
      console.log('share')
    },
    goItem(itemId) {
      //104財經熱點 105每日精選
      redirect('/news-item.html?itemId=' + itemId)
    },
    /* nowNews(){		//103即时新闻 滚动通知
				getNewsList([103, 1]).then(response => {
					this.nowNewsList = response.data.data.arr
					if(this.nowNewsList){
						for(let i=0; i<this.nowNewsList.length; i++){
							this.nowNewsText += this.nowNewsList[i].title + "\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0"
						}
					}
				})
				.catch(function(error) {
					console.log(error)
				})
			} */
    // 获取菜单
    getNavMenu(reset) {
      getNav()
        .then((response) => {
          if (!reset) {
            //如果是点了还原默认localStorage reset有值
            try {
              if (localStorage.getItem('nav')) {
                this.headerList = JSON.parse(localStorage.getItem('nav'))
                console.log('this.headerLis json : ', this.headerLis)
              }
              if (localStorage.getItem('nav2')) {
                this.headerList2 = JSON.parse(localStorage.getItem('nav2'))
                console.log('this.headerLis2 json : ', this.headerLis2)
              }
              if (localStorage.getItem('nav3')) {
                this.headerList3 = JSON.parse(localStorage.getItem('nav3'))
                console.log('this.headerList3 json : ', this.headerList3)
              }
              if (localStorage.getItem('originalNav')) {
                this.originalHeaderList = JSON.parse(
                  localStorage.getItem('originalNav')
                )

                this.findThirdUrl()
                // this.originalHeaderList = JSON.parse(JSON.stringify(response.data.data.arr))
                // localStorage.setItem('originalNav', JSON.stringify(this.originalHeaderList))
                console.log(
                  'this.originalHeaderList json : ',
                  this.originalHeaderList
                )
                return false
              }
            } catch (e) {
              this.returnOriginal()
              return false
            }
          }

          //第一次 或 还原频道后才会调用下面
          let arrObj = this.createNav()

          this.originalHeaderList = JSON.parse(
            JSON.stringify(response.data.data.arr)
          )
          this.originalHeaderList = this.originalHeaderList.concat(arrObj)

          localStorage.setItem(
            'originalNav',
            JSON.stringify(this.originalHeaderList)
          )

          this.originalLocalHeaderList = JSON.parse(
            JSON.stringify(response.data.data.arr)
          )

          this.originalLocalHeaderList.forEach((e) => {
            if (e.categoryType == 1) {
              this.headerList3.push(e)
            } else {
              this.headerList.push(e)
            }
          })

          //找到我的频道和地方频道中的部分第三方跳转url
          this.findThirdUrl()

          localStorage.setItem('nav3', JSON.stringify(this.headerList3))
          this.headerList = this.headerList.concat(arrObj)
          localStorage.setItem('nav', JSON.stringify(this.headerList))
        })
        .catch(function(error) {
          console.log(error)
        })
    },

    // 拖拽结束事件
    onEnd(e) {
      console.log('onEnd : ', e)
      var self = this
      this.drag = false

      // console.log(this.headerList.length)
      var obj = {
        categoryIcon: null,
        categoryId: 1,
        categoryName: '首頁',
        categoryType: 0,
        newsLst: null,
        orderNumber: 0,
        parentId: 0,
        url: '',
        moreArra: '',
      }

      this.headerList.splice(0, 1)
      this.$nextTick(function() {
        self.headerList.splice(0, 0, obj)
        self.storeNavToLS()
        console.log('onEnd headerList: ', this.headerList)
        console.log('onEnd headerList2: ', this.headerList2)
      })

      this.headerList.unshift(obj)
      this.headerList.shift()

      self.activeBeforeHomeDel = self.active
    },
    // 自定义控制那些元素可以拖拽或不允许拖拽
    onMove(e, originalEvent) {
      console.log('onMove e ', e)
      console.log('onMove originalEvent ', originalEvent)
      console.log('onMove e.to ', e.to.className)
      if (e.relatedContext.element) {
        let relate = e.relatedContext.element.categoryId
        let dragge = e.draggedContext.element.categoryId
        //不允许停靠
        if (
          relate == 1 ||
          relate == 102 ||
          relate == 98 ||
          relate == 999 ||
          relate == 99
        )
          return false
        //不允许拖拽
        if (
          dragge == 1 ||
          dragge == 102 ||
          dragge == 98 ||
          dragge == 999 ||
          dragge == 99
        )
          return false
      }
      if (e.draggedContext.element.categoryType == 1) {
        // console.log(e.related.className.indexOf("moveDrag2"))
        // if(e.related.className.indexOf("moveDrag2")!=-1){
        // 	return false
        // }
        if (e.to.className.indexOf('moveDrag2') != -1) {
          return false
        }
      }
      if (e.draggedContext.element.categoryType == 0) {
        if (e.to.className.indexOf('moveDrag3') != -1) {
          return false
        }
      }
      return true
    },
    onStart() {
      console.log('onStart this.headerList.length : ' + this.headerList.length)
      if (this.headerList.length <= 5) {
        //不可拖动 不可删除
        this.disableDragable = true
        this.catDelEnable = false
        return false
      }
    },
    // 编辑导航栏模式
    editNav() {
      this.disableDragable = !this.disableDragable
      this.isDel = !this.isDel
      if (this.disableDragable) {
        $('.btn_edit_nav.text_edit').html('编辑')
      } else {
        $('.btn_edit_nav.text_edit').html('完成')
      }
      this.catClickEnable = !this.catClickEnable
    },
    // 删除一个导航 我的频道->全部频道
    delNav(index, categoryType) {
      console.log('del index : ' + index)

      if (this.headerList.length <= 8) {
        //不可拖动 不可删除
        this.disableDragable = true
        this.catDelEnable = false
        return false
      }

      if (categoryType == 1) {
        //地方频道
        this.headerList3.push(this.headerList[index])
        this.headerList.splice(index, 1)
      } else {
        this.headerList2.push(this.headerList[index])
        this.headerList.splice(index, 1)
      }
      this.storeNavToLS()
    },
    // 添加一个导航 全部频道->我的频道
    addNav(index) {
      this.disableDragable = false //恢复拖动 删除
      this.catDelEnable = true

      this.headerList.splice(-3, 0, this.headerList2[index])
      console.log(this.headerList2[index])
      console.log(this.headerList)
      this.headerList2.splice(index, 1)
      this.storeNavToLS()
    },
    // 添加一个导航 全部频道->地方频道
    addNavLocal(index) {
      this.disableDragable = false //恢复拖动 删除
      this.catDelEnable = true

      this.headerList.splice(-3, 0, this.headerList3[index])
      this.headerList3.splice(index, 1)
      this.storeNavToLS()
    },
    // 关闭导航弹窗
    navPopClose() {
      this.$nextTick(function() {
        if (this.activeBeforeHomeDel == 1) {
          this.active = 1
        }

        this.disableDragable = true
        this.isDel = false
        $('.btn_edit_nav.text_edit').html('编辑')
        this.catClickEnable = true
      })
    },
    // 还原默认导航栏数据
    returnOriginal() {
      this.headerList = []
      this.headerList2 = []
      this.headerList3 = []
      this.originalHeaderList = []
      this.originalLocalHeaderList = []
      localStorage.removeItem('nav')
      localStorage.removeItem('nav2')
      localStorage.removeItem('nav3')
      localStorage.removeItem('originalNav')
      this.getNavMenu(1)
      this.storeNavToLS()
    },
    // 切换自定义导航或默认导航
    switchNavTabs(name) {
      if (name == 0) {
        //默认
        if (!this.isNavDefaultRefreshed) {
          getNav()
            .then((response) => {
              let arrObj = this.createNav()

              this.originalHeaderList = JSON.parse(
                JSON.stringify(response.data.data.arr)
              )
              this.originalHeaderList = this.originalHeaderList.concat(arrObj)

              localStorage.setItem(
                'originalNav',
                JSON.stringify(this.originalHeaderList)
              )

              this.isNavDefaultRefreshed = true
            })
            .catch(function(error) {
              console.log(error)
            })
        }

        this.navCostomShow = false
        this.navDefaultShow = true
        // $('.btn_edit_nav').attr("readonly",true);
        $('.btn_edit_nav').hide()
        $('.btnNavTemp').show()
      } else {
        //自定义
        this.navDefaultShow = false
        this.navCostomShow = true
        // $('.btn_edit_nav').attr("readonly",false);
        $('.btnNavTemp').hide()
        $('.btn_edit_nav').show()
      }
    },

    // 保存到localStorage
    storeNavToLS() {
      localStorage.setItem('nav', JSON.stringify(this.headerList))
      localStorage.setItem('nav2', JSON.stringify(this.headerList2))
      localStorage.setItem('nav3', JSON.stringify(this.headerList3))
    },

    createNav() {
      let arrObj = new Array()
      const localobj = {
        categoryIcon: null,
        categoryId: 102,
        categoryName: '地方',
        categoryType: 2,
        newsLst: null,
        orderNumber: 0,
        parentId: 0,
        url: '',
      }

      const szbobj = {
        categoryIcon: null,
        categoryId: 98,
        categoryName: '數字報',
        categoryType: 2,
        newsLst: null,
        orderNumber: 0,
        parentId: 0,
        url: '',
      }

      const jrsbobj = {
        categoryIcon: null,
        categoryId: 99,
        categoryName: '今日商報',
        categoryType: 2,
        newsLst: null,
        orderNumber: 0,
        parentId: 0,
        url: '',
      }

      const pdfobj = {
        categoryIcon: null,
        categoryId: 999,
        categoryName: 'PDF',
        categoryType: 0,
        newsLst: null,
        orderNumber: 0,
        parentId: 0,
        url: '',
        moreArra: '',
      }

      arrObj.push(localobj)
      arrObj.push(szbobj)
      // arrObj.push(jrsbobj)
      arrObj.push(pdfobj)
      return arrObj
    },

    //生成文章id+随机数 用于列表key
    genRandomKey(id) {
      return id + '-' + Math.round(Math.random() * 10000)
    },
    //广告位置, 频道ID
    siteChannelId(adPos, curCatId) {
      if (!this.adChannelIdArr || this.adChannelIdArr.length <= 0) {
        this.getAdChannelId()
      }

      let u = '//ads.adserver.newsochub.com/show/std?scid='
      let url = ''
      let u2 = '&f=iframe'

      for (let i = 0; i < this.adChannelIdArr.length; i++) {
        if (curCatId == this.adChannelIdArr[i].cat_id) {
          url = this.adChannelIdArr[i].ad_channel_id
          break
        }
      }

      return u + url + u2
    },

    isLocalChannel(curCatId) {
      //地方频道不显示广告
      if (this.placeId.indexOf(curCatId) == -1) {
        return false
      }
      return true
    },

    tongjiPhp(curCatId) {
      tongjiPhp({ channel: 'H5', category_id: this.curCatId }).then(
        (response) => {
          console.log(response)
        }
      )
    },

    getAdChannelId() {
      //获取所有频道的广告id
      if (!this.adChannelIdArr || this.adChannelIdArr.length <= 0) {
        getAdChannelId()
          .then((response) => {
            console.log(
              'getAdChannelId',
              process.env.AD_CHANNEL_ID,
              response.data.data
            )
            this.adChannelIdArr = response.data.data
          })
          .catch(function(error) {
            console.log(error)
          })
      }
    },

    //找到需要跳到第三方页的频道的跳转url
    findThirdUrl() {
      this.originalHeaderList.forEach((e) => {
        //导航地方频道list
        this.thirdUrlCategorys(e)
      })
      console.log('兩會url', this.twoMeetingsUrl)
      console.log('廈門url', this.xiamenUrl)
    },

    //需要判断第三方跳转url的频道
    thirdUrlCategorys(e) {
      if (e.categoryId == 203) {
        //兩會
        this.twoMeetingsUrl = e.url
      } else if (e.categoryId == 202) {
        //廈門
        this.xiamenUrl = e.url
      }
    },
  },

  mounted() {
    tongji()
    this.tongjiPhp()
    //如果有channel参数就跳去categoryId=113体育专区 并且隐藏菜单头脚
    let channel = getUrlParam('channel')
    if (channel) {
      $('#header').hide()
      $('#footer').hide()
      $('#nav').hide()
      $('.nav-bar').hide()
      $('#content').css('margin-top', 0)
      this.goNav(113)
    } else {
      //首次加载类别导航
      this.getNavMenu()

      this.getNews()
    }

    /**
     * iframe-宽高自适应显示
     */
    // const oIframe = document.getElementById('listIframe')
    // // const deviceWidth = document.documentElement.clientWidth
    // const deviceHeight = document.documentElement.clientHeight
    // // // oIframe.style.width = (Number(deviceWidth)-0) + 'px'; //数字是页面布局宽度差值
    // oIframe.style.height = (Number(deviceHeight)+0) + 'px'; //数字是页面布局高度差
  },
}
</script>

<style src="@/style/index.css"></style>

<style>
.ad_con {
  background-color: #fff;
  text-align: center;
  width: 100%;
  height: auto;
}

.ad_con iframe {
  width: 300px;
  min-height: 250px;
  text-align: center;
  margin: 0 auto;
}

#banner {
  width: 100% !important;
  min-height: 330px;
}

#banner img {
  width: 100%;
  height: 100%;
}
.hide {
  display: none;
}

.list-iframe {
  border: 0;
  height: 100%;
  width: 100%;
  position: relative;
  /* height: 400px; */
}
</style>



// WEBPACK FOOTER //
// src/list/pages/index/index.vue